import { hotjar } from "react-hotjar";
export var hotjarInterceptor = function(params) {
    if (params.bypassSessionRecording) {
        // Do not pass event to Hotjar if bypassing session recording
        return;
    }
    try {
        hotjar.event(params.eventKey);
    } catch (_) {
    /* ignore */ }
};
